import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { useAuth } from "auth";
import { networkTypeSelector } from "store/userSliceHelpers";
import { useSettlementToken } from "features/tokens/useSettlementToken";
import { getCardBalance } from "utils/AxiosUtil";
import { isNoAddress } from "utils/card";

export function useCardBalance(
  cardNumber: string | undefined,
  cardAlias: string | undefined,
) {
  const { user } = useAuth();
  const networkType = useSelector(networkTypeSelector);
  const { param: token } = useSettlementToken();
  const hasAddress = !!cardAlias && !isNoAddress(cardAlias);
  return useQuery<number>({
    // Token in the key is load-bearing: staleTime is Infinity, so without it a switch would
    // serve the old token's balance under the new label and never refetch.
    queryKey: ["cardBalance", cardNumber, token],
    queryFn: () => getCardBalance(cardNumber!, networkType, token),
    enabled: !!user && !!cardNumber && hasAddress,
  });
}
